import { TruncatedTooltip } from '@/components/ui/truncated-tooltip';
import { cn } from '@/lib/utils';

interface TimeOffDescriptionCellProps {
  description: string | null;
  isPast: boolean;
}

export const TimeOffDescriptionCell = ({ description, isPast }: TimeOffDescriptionCellProps) => {
  if (!description) {
    return <span className={cn('text-muted-foreground', isPast && 'opacity-50')}>{'-'}</span>;
  }

  return (
    <TruncatedTooltip
      content={description}
      preserveWhitespace
      className={cn('text-sm', isPast && 'opacity-50')}
    />
  );
};
